export const externalId = (state) => state.StartUp.queryString.id;